import script from "./ServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesView.vue?vue&type=script&setup=true&lang=js"

import "./ServicesView.vue?vue&type=style&index=0&id=dd3e33a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd3e33a4"]])

export default __exports__